import React, { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGithub } from '@fortawesome/free-brands-svg-icons'
import Modal from '@react/shared/ui/Modal'
import GithubIssueDetail from '@shared/github/IssueDetail'
import { fetchIssue } from '../api'
import { REACH_GITHUB } from '../helpers'

// The card shows a comment posted from this page under the CSM's name, not the app's.
const withAuthors = (issue) => ({
  ...issue,
  comments: (issue.comments || []).map(comment => (
    comment.signed_by ? { ...comment, author: { login: comment.signed_by } } : comment
  ))
})

const IssueModal = ({ number, issuePath, onClose }) => {
  const [issue,  setIssue]  = useState(null)
  const [notice, setNotice] = useState(null)

  useEffect(() => {
    if (!number) return
    setIssue(null)
    setNotice(null)
    fetchIssue(issuePath, number)
      .then(data => (data && data.error ? setNotice(data.error) : setIssue(withAuthors(data))))
      .catch(() => setNotice(REACH_GITHUB))
  }, [number, issuePath])

  return (
    <Modal
      isOpen={!!number}
      onClose={onClose}
      size="lg"
      title={`Ticket GitHub #${number}`}
      footer={issue && (
        <a
          href={issue.html_url}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 text-[13px] font-medium text-brand-600 no-underline hover:text-brand-700 hover:underline"
        >
          <FontAwesomeIcon icon={faGithub} />
          Voir sur GitHub
        </a>
      )}
    >
      {notice && <p className="m-0 text-[13px] text-slate-600">{notice}</p>}
      {!issue && !notice && (
        <div className="flex justify-center py-12 text-slate-400"><FontAwesomeIcon icon="circle-notch" spin size="2x" /></div>
      )}
      {issue && <GithubIssueDetail issue={issue} />}
    </Modal>
  )
}

export default IssueModal
